export enum ObjectType {
    Product = 'product',
    Attribute = 'attribute',
    Page = 'page',
}
